<div class="service-detail-page">
    <div class="container">

        <header appFadeInReveal>
            <h1>Terapia para Adultos</h1>
            <div class="header-description">
                <p class="lead-text">
                    A veces la vida se vuelve pesada. La ansiedad, el cansancio emocional, las dudas, los miedos o la
                    sensación de no estar bien con uno mismo pueden aparecer sin previo aviso.
                </p>
                <p>
                    La terapia es un espacio para parar, mirar hacia dentro y entender qué te está pasando. Un lugar
                    seguro donde no tienes que tener todas las respuestas, solo el deseo (o la necesidad) de sentirte
                    mejor.
                </p>
                <p>
                    Trabajamos a tu ritmo, con escucha, sin juicios, y con herramientas que te ayuden a reconectar
                    contigo, tomar decisiones con claridad y vivir con más calma y coherencia.
                </p>
            </div>
            <p class="intro-text">
                ¿Cuándo puede ayudarte la terapia?
            </p>
        </header>

        <section appFadeInReveal>
            <p>La terapia con adultos puede acompañarte si te sientes identificada con alguna de estas situaciones:</p>
            <ul class="check-list">
                <li>Ansiedad o estrés que afectan a tu día a día.</li>
                <li>Dificultad para tomar decisiones o sentir claridad.</li>
                <li>Cansancio emocional o sensación de estar desbordada.</li>
                <li>Baja autoestima, autocrítica intensa o inseguridad.</li>
                <li>Ciclos repetitivos en relaciones afectivas.</li>
                <li>Duelo, separación o cambios vitales importantes.</li>
                <li>Necesidad de un espacio personal donde entender qué te pasa.</li>
                <li>Deseo de conocerte mejor y fortalecer tu bienestar emocional.</li>
            </ul>
        </section>

        <section appFadeInReveal>
            <div class="content-block">
                <div class="image">
                    <img src="/services_03.webp" alt="Terapia adultos Santander" class="photo--mask"
                        fetchpriority="high">
                </div>
                <div class="text">
                    <h2>¿Qué puedes conseguir con la terapia?</h2>
                    <p>La terapia puede ayudarte a:</p>
                    <ul class="check-list">
                        <li>Reducir ansiedad y recuperar calma.</li>
                        <li>Mejorar tu relación contigo misma.</li>
                        <li>Comprender mejor tus emociones.</li>
                        <li>Aumentar autoestima y seguridad.</li>
                        <li>Tomar decisiones con claridad.</li>
                        <li>Fortalecer tus relaciones.</li>
                        <li>Acompañar procesos de duelo o cambio.</li>
                        <li>Crear una vida más coherente con tus valores.</li>
                    </ul>
                </div>
            </div>
        </section>

        <div class="cta-container" appFadeInReveal>
            <a routerLink="/contacto" class="btn-primary">Pedir Cita</a>
        </div>

    </div>
</div>